import { mailReadingPaneRouteHandler } from './mailReadingPaneRouteHandler';
import { registerRoute } from 'owa-router';
import { setCalendarViewRouteParams } from 'mini-mail-reading-pane-store/lib/actions/calendarViewDetails/setCalendarViewRouteParams';

const CONVERSATION_VIEW_SUB_PATH = ':folderId/id/:conversationId';
const ITEM_VIEW_SUB_PATH = ':folderId/itemId/:itemId';

const EVENT_DETAILS_SUB_PATH = 'event/:eventId/details';
const EVENT_EDIT_SUB_PATH = 'event/:eventId/edit/:scope';

const DETAILS_SPOKE_SUB_PATH = 'spoke/:spokeType/:scope';
const EDIT_SPOKE_SUB_PATH = 'spoke/:spokeType';

const ATTENDEE_CARD_SUB_PATH = 'card/:routeIdType/:routeId/:view';

export const registerRsvpViewRoutes = (defaultRoute: string): void => {
    // For edit and details main screen
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );

    // For spokes
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );

    // For attendee cards
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(true)
    );
    registerRoute(
        `${defaultRoute}${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
    registerRoute(
        `${defaultRoute}${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        rsvpViewRouteHandlerGenerator(false)
    );
};

const rsvpViewRouteHandlerGenerator = (isEdit: boolean) => async params => {
    await mailReadingPaneRouteHandler(params);
    setCalendarViewRouteParams({ ...params, isEdit });
};
